import React, { FC, useCallback } from 'react';
import { Tooltip } from 'antd';
import { ProductCard } from '@cloudcar-app/cloudcar-components';
import currencyFormatter from 'utils/currencyFormatter';
import styles from './ProcedureCard.module.scss';

interface ProcedureCardProps {
  name: string;
  icon: string;
  selected: boolean;
  disabled: boolean;
  price: number;
  onClick: () => void;
  exceptionMessage?: string;
  included?: boolean;
}

const ProcedureCard: FC<ProcedureCardProps> = (props: ProcedureCardProps) => {
  const {
    name,
    icon,
    selected,
    disabled,
    price,
    onClick,
    exceptionMessage,
    included,
  } = props;

  const getProcedurePriceRepresentation = () => {
    if (included) {
      return 'Incluido';
    }
    if (price) {
      return currencyFormatter.format(price);
    }
    return '-';
  };

  const BaseComponent = useCallback(
    () => (
      <ProductCard
        onClick={onClick}
        selected={selected}
        disabled={disabled}
        className={styles.ProcedureCard}
      >
        <img src={icon} alt={name} className={styles.Icon} />
        <p>{name}</p>
        <span>{getProcedurePriceRepresentation()}</span>
      </ProductCard>
    ),
    [selected, name, price, disabled, onClick, icon],
  );

  if (exceptionMessage) {
    return (
      <Tooltip title={exceptionMessage}>
        <div>
          <BaseComponent />
        </div>
      </Tooltip>
    );
  }

  return <BaseComponent />;
};

ProcedureCard.defaultProps = {
  exceptionMessage: undefined,
  included: undefined,
};

export default ProcedureCard;
